<template>
  <v-app>
    <v-main>
      <Legend></Legend>
      <MapComponent></MapComponent>
      <ReportingControls></ReportingControls>
    </v-main>
  </v-app>
</template>

<script>
/* eslint-disable import/no-unresolved */
import { mapActions } from 'vuex';
import ReportingControls from '@/components/ReportingControls.vue';
import MapComponent from '@/components/Map.vue';
import Legend from '@/components/Legend.vue';

export default {
  name: 'App',

  components: { MapComponent, ReportingControls, Legend },

  data() {
    return {
      organisationGUID: process.env.VUE_APP_ORG_ID
    }
  },
  watch: {
    $route() {
      this.setCurrentUser({ organisationGUID: this.organisationGUID });
      // react to route changes...
    }
  },
  mounted() {
    this.setCurrentUser({ organisationGUID: this.organisationGUID })
  },
  methods: {
    ...mapActions(['setCurrentUser']),
  },
}
</script>
